/** Serviços Codilo com permissão para acessar o SupReq. */
export const ALLOWED_AUTH_SERVICES = ['codilo-admin', 'codilo-staff'] as const;
